// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionHeader_section_10yKo","header":"SectionHeader_header_3V9XB","subheader":"SectionHeader_subheader_7LfKh"};